<template>
    <div id="layout-main">
        <nav>
            <router-link to="/">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1366.69 154.59" id="boomerang-logo">
                <title>Logo</title>
                <g data-name="boomerang-logo">
                    <path class="b" d="M0,154.37V0H78.29q22,0,30.66,21.61a29.73,29.73,0,0,1,2.19,11V51.16q0,17.43-13.22,25.37,10.14,4.84,12.79,18.74a19.55,19.55,0,0,1,.43,4.85v14.34q0,39.9-35.49,39.91-2.88.21-19,.22Q37.71,154.59,0,154.37ZM73.21,66.6q6.84,0,11-4.1t4.19-11V36.67q0-11.28-13-14a8.15,8.15,0,0,0-2.65-.45H21.83V66.6ZM21.83,132.1H72.56q8.59,0,13.45-8.38a15.88,15.88,0,0,0,2.42-7.94V101.22q0-6.82-8.38-10.8a16.49,16.49,0,0,0-7-1.55H21.83Z"/>
                    <path class="o-a" d="M126.67,87.89V27.67q0-23.8,25.81-26.9a24.49,24.49,0,0,0,2.64-.21h37.94a35,35,0,0,1,4.63.44q26.24,3.75,26.24,26.67V87.89q0,15.87-15.88,24.91a29.66,29.66,0,0,1-15,3.53H156.89q-22,0-28.89-21Q125.57,88.33,126.67,87.89Zm78.07-54.21q0-14-13.55-13.94H159.86q-14,0-14,13.94v48q0,15.48,14,15.48h31.33q13.56,0,13.55-14.82"/>
                    <path class="o-b" d="M239.81,87.89V27.67q0-23.8,25.81-26.9a24.68,24.68,0,0,0,2.64-.21H306.2a35.13,35.13,0,0,1,4.63.44q26.24,3.75,26.24,26.67V87.89q0,15.87-15.88,24.91a29.71,29.71,0,0,1-15,3.53H270q-22,0-28.89-21Q238.71,88.33,239.81,87.89ZM273,97.15h31.33q13.56,0,13.55-14.82V33.68q0-14-13.55-13.94H273q-14,0-14,13.94v48Q259,97.15,273,97.15Z"/>
                    <path class="m" d="M374.16,29.86Q374.82,25,376.6,23c1.18-1.32,3.4-2.12,6.66-2.42a8,8,0,0,1,2.21-.22h15.3q10,0,12,9.9a5.93,5.93,0,0,0,.23,1.11v84.92h19.18V32.53q0-10.58,7.72-12.13h17q11.68,0,11.69,11v84.91h19.18V29.88Q487.73.56,461.05.56H443.63a35.27,35.27,0,0,0-4.85.44q-12.58,1.76-17.42,9.7Q416.28,2.75,403.93,1a35.53,35.53,0,0,0-4.85-.44H381.66Q355,.56,355,29.88v86.45h19.19Z"/>
                    <path class="e" d="M600.09,31.65v13.9q0,15.66-6.86,25.13-7.74,10.81-22.78,10.81H522.69v7.83a7.75,7.75,0,0,0,2.2,5.48A6.8,6.8,0,0,0,530,97.15h70.11v19.18H531.51q-22.72,0-27.57-21.38a45.52,45.52,0,0,1-.44-5.3V30.11a27.65,27.65,0,0,1,4.19-14.77Q516.95.55,531.72.56h38.6q8.59,0,16.76,5.95a31,31,0,0,1,11.24,14.11A31.83,31.83,0,0,1,600.09,31.65Zm-24.3-10.14c-2.22-1.19-5.85-1.77-10.88-1.77H538.68q-16,0-16,11.47V50q0,11,13.55,12.34h30.89Q580.9,60.76,580.9,50V31.21Q580.9,24.16,575.79,21.51Z"/>
                    <path class="r" d="M631.29,31.45q0-11.71,10.71-11.71h46.34V.56H640.78a32.89,32.89,0,0,0-5.07.44q-11.48,1.76-16.66,6.94t-6.5,16.65a56.17,56.17,0,0,0-.44,6.62v85.12h19.18Z"/>
                    <path class="boomerang-left" d="M693,62.7c-12.79,22.94-17.7,44.77-12.71,50.62,6.81,8,28.92-1.42,52.8-10.53Z"/>
                    <path class="boomerang-middle" d="M859.84,48.09c-18.05-25.22-45.25-48-79-48s-60.52,22.6-78.35,47.71L751,96.35c10.84-3.57,21.36-6.2,30.29-6.2s19.43,2.63,30.26,6.19Z"/>
                    <path class="boomerang-right" d="M829.51,102.79c23.89,9.11,46,18.51,52.82,10.53,5-5.83-.07-27.54-13-50.39Z"/>
                    <path class="n" d="M926.88,32.75q0-7.28,3-9.92t10.34-2.65h30.9q11.55,0,13.11,7.28v88.87h19.18v-86Q1003.4.56,970.76.56H940.33q-32.64,0-32.64,29.76v86h19.19Z"/>
                    <path class="g" d="M1088.3.56h-40.79a27.21,27.21,0,0,0-9.93,2.19q-17.43,7.08-17.43,27.36V84.8a31.72,31.72,0,0,0,8.52,22.27,28,28,0,0,0,21.56,9.26h46.23v4.86q0,13.65-14.6,13.66H126.33V154h956.23q14.57,0,23.39-6.83,9.69-7.52,9.7-21.62v-97a37.81,37.81,0,0,0-.44-5.07Q1111.9.55,1088.3.56Zm8.16,84.64c0,3.69-.93,6.61-2.78,8.74a9.59,9.59,0,0,1-7.66,3.21h-34.23q-10.45,0-12.44-12.17V32.56q0-10.83,11.11-12.82H1086q10.44,0,10.44,13.05Z"/>
                    <path class="digit-two" d="M1153.44,22.38h65.46a15.25,15.25,0,0,1,2.66.45q7.29,1.55,8.62,10.19v6.44a8.86,8.86,0,0,1-.88,4,7.93,7.93,0,0,1-3.54,4.89,10,10,0,0,1-6.2,2.43h-32.28q-10.85,0-21.46,8.36-12.37,9.67-12.38,29.25v29.36h99l.29-19.63h-76.3l-.29-11.83q0-13.23,13.68-13.24h29.55q9.46,0,18.74-6.17,14.34-9.48,14.33-27.35V31.87q0-9-6.17-18.08Q1237,.11,1217.17.11h-63.73Z"/>
                    <path class="d" d="M1273.92,55.75v62h56.17a36,36,0,0,0,15.43-3.75q21.18-10.14,21.17-35.51V36.39q0-15.21-8.82-25.46T1334.28.67h-60.36V36.61h22.28V22.94h32.12q8.16,0,11.58,3.09t4.3,11.24a9.75,9.75,0,0,0,.22,1.54v37.9q0,18.75-15.44,18.74H1296.2V55.75Z"/>
                </g>
            </svg>
            </router-link>

            <router-link
                    v-for="link in links"
                    v-bind:key="link.to"
                    :to="link.to"
                    :class="[{selected: link.selected}, {'last-in-group': link.lastInGroup}]"
            >
                {{link.text}}
            </router-link>
<!--            <a href="http://demo.boomerang2d.com" target="_blank" class="last-in-group"><i class="fas fa-gamepad"></i>Demo</a>-->
<!--            <a href="http://documentation.boomerang2d.com" target="_blank" class="last-in-group"><i class="fas fa-book-open"></i>Documentation</a>-->
<!--            <a href="https://trello.com/b/QZKruTWz/boomerang2d-roadmap" target="_blank" class="last-in-group"><i class="fab fa-trello"></i>Roadmap</a>-->
            <a href="https://discord.gg/F4tpUHJsvj" target="_blank"><i class="fab fa-discord"></i>Join us on Discord</a>
        </nav>


        <div id="header-graphic">
            <img src="../assets/header-center.png" alt="Header Graphic"/>
        </div>

        <header id="up-sell-header" v-if="showUpSellBox">
            <div class="text-container">
                <p>A <em>Visual Building-Block</em> approach to building <em>Pixel Perfect 2D</em> games in Unity <em>without code</em>.
                </p>
            </div>

            <a class="up-sell-unity" href="https://assetstore.unity.com/packages/slug/164608" target="_blank">
                <i class="fab fa-unity"></i>
                Get Boomerang2D from the Unity Asset Store
            </a>
        </header>

        <div id="content">
            <router-view></router-view>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'mainLayout',

        computed: {
            links() {
                let selectedRoute = this.$route.meta.subNavRoute;

                return [
                    {
                        to: '/',
                        text: 'Features',
                        selected: selectedRoute === 'Features',
                        lastInGroup: true
                    },
                    {
                        to: '/Manual',
                        text: 'Manual',
                        selected: selectedRoute === 'Manual',
                        lastInGroup: true
                    },
                    // {
                    //     to: '/Manual',
                    //     text: 'Manual',
                    //     selected: selectedRoute === 'Manual',
                    //     lastInGroup: false
                    // },
                    // {
                    //     to: '/Documentation',
                    //     text: 'Documentation',
                    //     selected: selectedRoute === 'Documentation',
                    //     lastInGroup: true
                    // },
                    // {
                    //     to: '/Cookbook',
                    //     text: 'Cookbook',
                    //     selected: selectedRoute === 'Cookbook',
                    //     lastInGroup: false
                    // },
                    // {
                    //     to: '/AddOnPackages',
                    //     text: 'Add-on Packages',
                    //     selected: selectedRoute === 'AddOnPackages',
                    //     lastInGroup: false
                    // },
                    // {
                    //     to: '/Showcase',
                    //     text: 'Showcase',
                    //     selected: selectedRoute === 'Showcase',
                    //     lastInGroup: true
                    // }
                ]
            },

            showUpSellBox() {
                return this.$route.meta.subNavRoute === 'Features';
            }
        }
    }
</script>